import { Component, Input, OnInit, TemplateRef } from '@angular/core'
import { isPanelOnActiveTab, RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'

@Component({
  selector: 'hs-lazy-load-panel[panelKey]',
  styleUrls: ['lazy-load-panel.component.scss'],
  templateUrl: 'lazy-load-panel.component.html',
})
export class LazyLoadPanelComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null
  @Input() panelKey: string | null = null

  isPanelOnActiveTab$!: Observable<boolean>

  constructor(private readonly store: Store<RootState>) {}

  ngOnInit() {
    if (this.panelKey == null) return
    this.isPanelOnActiveTab$ = this.store.pipe(
      isPanelOnActiveTab(this.panelKey),
    )
  }
}
